import * as mutationTypes from 'store/mutationTypes'
import * as actions from './actions'

export default {
  state: {
    booking: null,
    cart: null,
    order: null,
    items: [],
    checkingOut: false,
    paymentProfile: null,
    paymentType: null,
    stripePaymentRequest: null,
    stripePaymentRequestResult: null,
  },
  actions,
  mutations: {
    [mutationTypes.SET_CHECKOUT_BOOKING](state, booking) {
      state.booking = booking
    },
    [mutationTypes.SET_CHECKOUT_CART](state, cart) {
      state.cart = cart
    },
    [mutationTypes.SET_CHECKOUT_ORDER](state, order) {
      state.order = order
    },
    [mutationTypes.START_CHECKOUT](state) {
      state.checkingOut = true
    },
    [mutationTypes.CLEAR_CHECKOUT_CART_ITEMS](state) {
      state.checkingOut = false
      state.items = []
    },
    [mutationTypes.ADD_CART_ITEM](state, item) {
      state.items.push(item)
    },
    [mutationTypes.REMOVE_CART_ITEM](state, item) {
      const index = state.items.indexOf(item)

      state.items.splice(index, 1)
    },
    [mutationTypes.SET_CHECKOUT_PAYMENT_PROFILE](state, paymentProfile) {
      state.paymentProfile = paymentProfile
    },
    [mutationTypes.SET_CHECKOUT_PAYMENT_TYPE](state, paymentType) {
      state.paymentType = paymentType
    },
    [mutationTypes.SET_CHECKOUT_STRIPE_PAYMENT_REQUEST](state, stripePaymentRequest) {
      state.stripePaymentRequest = stripePaymentRequest
    },
    [mutationTypes.SET_CHECKOUT_STRIPE_PAYMENT_REQUEST_RESULT](state, stripePaymentRequestResult) {
      state.stripePaymentRequestResult = stripePaymentRequestResult
    },
  },
}



// WEBPACK FOOTER //
// ./src/store/modules/checkout/index.js